import { render } from "./GatherFeedbackView.vue?vue&type=template&id=3e4fad55"
import script from "./GatherFeedbackView.vue?vue&type=script&lang=js"
export * from "./GatherFeedbackView.vue?vue&type=script&lang=js"

import "./GatherFeedbackView.vue?vue&type=style&index=0&id=3e4fad55&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__